var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgESignProgress(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#F0F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Application Processing",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 970,
    transform: "translate(-284 -152)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bold Duotone / Essentional, UI / Danger Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M58.6673 31.9987C58.6673 17.2711 46.7282 5.33203 32.0007 5.33203C17.2731 5.33203 5.33398 17.2711 5.33398 31.9987C5.33398 46.7263 17.2731 58.6654 32.0007 58.6654C46.7282 58.6654 58.6673 46.7263 58.6673 31.9987Z",
    fill: "#1177BD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0007 16.668C33.1052 16.668 34.0007 17.5634 34.0007 18.668V34.668C34.0007 35.7725 33.1052 36.668 32.0007 36.668C30.8961 36.668 30.0007 35.7725 30.0007 34.668V18.668C30.0007 17.5634 30.8961 16.668 32.0007 16.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0007 45.3346C33.4734 45.3346 34.6673 44.1407 34.6673 42.668C34.6673 41.1952 33.4734 40.0013 32.0007 40.0013C30.5279 40.0013 29.334 41.1952 29.334 42.668C29.334 44.1407 30.5279 45.3346 32.0007 45.3346Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 970,
    fill: "white",
    transform: "translate(-284 -152)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgESignProgress);
export default __webpack_public_path__ + "static/media/e-sign-progress.8a983dc82caedc1ce27f2f7480de7aa2.svg";
export { ForwardRef as ReactComponent };